import classnames from 'classnames/bind';
import * as styles from './WarehouseCard.css';

const cx = classnames.bind(styles);

export function CardList({ children }) {
    return (
        <div className={cx('card-list')} role="listbox">
            <div className={cx('cards')}>{children}</div>
        </div>
    );
}
